import Vue from 'vue';
import VueRouter from 'vue-router';

import ConsoleHome from './components/core/ConsoleHome';
import ConsoleDashboard from './components/core/ConsoleDashboard';
import Usage from './components/usage/Usage';
import Pricing from './components/pricing/Pricing';
import Bonus from './components/bonus/Bonus';
import Register from './components/register/Register';
import RegisterSuccess from './components/register/RegisterSuccess';
import Confirm from './components/confirm/Confirm';
import Login from './components/login/Login';
import SSOLogin from './components/sso-login/SSOLogin';
import Unauthorized from './components/core/Unauthorized';
import PageNotFound from './components/core/PageNotFound';
import InvoiceHistory from './components/invoice/InvoiceHistory';
import InvoiceDetails from './components/invoice/InvoiceDetails';
import SendReset from './components/reset/SendReset';
import Reset from './components/reset/Reset';
import ResetSuccess from './components/reset/ResetSuccess';
import ResetPrompt from './components/reset/ResetPrompt';
import Payment from './components/payment/Payment';
import PublicKeyList from './components/public-keys/PublicKeyList';
import Terms from "./components/terms/Terms";
import Prices from "./components/prices/Prices";
import IndexPage from "./components/index/IndexPage";
import IndexLanding from "./components/index/IndexLanding";
import GitPullWizard from "./components/git-config/GitPullWizard";
import TestRunnerWrapper from "./components/test-runner/TestRunnerWrapper";
import TestRunnerDashboard from '@/components/test-runner/TestRunnerDashboard';

import store from './store';

Vue.use(VueRouter);

const Access = {
	PUBLIC: 'PUBLIC',
	AUTHENTICATED: 'AUTHENTICATED',
	ADMIN_ONLY: 'ADMIN_ONLY',
}

const router = new VueRouter({
	mode: 'history',
	routes: [{
		path: '/',
		redirect: { name: 'IndexPage' }
	},
	{
		path: '/console',
		component: ConsoleHome,
		children: [
			{
				path: '',
				component: ConsoleDashboard,
				name: 'ConsoleDashboard',
				meta: { access: Access.AUTHENTICATED },
			},
			{
				path: 'usage',
				component: Usage,
				meta: { access: Access.AUTHENTICATED },
			},
			{
				path: 'payment',
				name: 'Payment',
				component: Payment,
				meta: { access: Access.AUTHENTICATED },
			},
			{
				path: 'payment/history',
				name: 'payment-history',
				component: InvoiceHistory,
				meta: { access: Access.AUTHENTICATED },
			},
			{
				path: 'payment/details',
				name: 'payment-details',
				component: InvoiceDetails,
				meta: { access: Access.AUTHENTICATED },
			},
			{
				path: 'pricing',
				component: Pricing,
				meta: { access: Access.ADMIN_ONLY },
			},
			{
				path: 'bonus',
				component: Bonus,
				meta: { access: Access.ADMIN_ONLY },
			},
			{
				path: 'access-key',
				name: 'PublicKeyList',
				component: PublicKeyList,
				meta: { access: Access.ADMIN_ONLY },
			},
			{
				path: 'git-pull',
				name: 'GitPull',
				component: GitPullWizard,
				meta: { access: Access.AUTHENTICATED },
			},
			{
				path: 'run-tests',
				name: 'RunTests',
				component: TestRunnerWrapper,
				meta: { access: Access.AUTHENTICATED },
			},
			{
				path: 'test-runner-dashboard',
				name: 'TestRunnerDashboard',
				component: TestRunnerDashboard,
				meta: { access: Access.AUTHENTICATED },
			},
			{
				path: 'register',
				component: Register,
				meta: { access: Access.PUBLIC },
			},
			{
				path: 'register/success',
				component: RegisterSuccess,
				meta: { access: Access.PUBLIC },
			},
			{
				path: 'confirm',
				component: Confirm,
				meta: { access: Access.PUBLIC },
			},
			{
				path: 'login',
				component: Login,
				name: 'Login',
				meta: { access: Access.PUBLIC },
			},
			{
				path: 'login/sso',
				component: SSOLogin,
				name: 'SSOLogin',
				meta: { access: Access.PUBLIC },
			},
			{
				path: 'reset',
				component: Reset,
				meta: { access: Access.PUBLIC },
			},
			{
				path: 'reset/send',
				component: SendReset,
				meta: { access: Access.PUBLIC },
			},
			{
				path: 'reset/prompt',
				component: ResetPrompt,
				meta: { access: Access.PUBLIC },
			},
			{
				path: 'reset/success',
				component: ResetSuccess,
				meta: { access: Access.PUBLIC },
			},
			{
				path: 'prices',
				component: Prices,
			},
			{
				path: 'terms',
				component: Terms,
			},
			{
				path: 'unauthorized',
				component: Unauthorized,
				name: 'Unauthorized'
			},
		]
	},
	{
		path: '/index',
		component: IndexPage,
		children: [{
			path: '',
			name: 'IndexPage',
			component: IndexLanding,
		},
		{
			path: 'terms',
			component: Terms,
		},
		{
			path: 'prices',
			component: Prices,
		}]
	},
	{
		path: '*',
		component: PageNotFound,
		name: 'PageNotFound',
	},
	],
});

router.beforeEach(async (to, from, next) => {
	await store.state.consoleReady$.promise;

	if (to.matched.some(record => record.meta.access === Access.AUTHENTICATED || record.meta.access === Access.ADMIN_ONLY)) {
		if (!store.getters.isAuthenticated) {
			return next({ name: 'Login', query: { next: encodeURI(to.path) } });
		}
	}

	if (to.matched.some(record => record.meta.access === Access.PUBLIC)
		&& store.getters.isAuthenticated) {
		return next({ name: 'ConsoleDashboard' });
	}

	if (to.matched.some(record => record.meta.access === Access.ADMIN_ONLY) && !store.state.authData.isAdmin) {
		return next({ name: 'Unauthorized' });
	}

	return next();
});

export default router;
